import React, { FC } from "react";

export interface IFormItem {
  id: string;
  label: string;
  optionalLabel?: string;
  children?: React.ReactNode;
  labelColor?: string;
}

const FormItem: FC<IFormItem> = ({
  children,
  id,
  label,
  optionalLabel,
  labelColor = "",
}) => {
  return (
    <div className="">
      <label
        htmlFor={id}
        className={`block text-sm font-medium ${
          labelColor ? labelColor : "text-gray-700"
        }`}
      >
        <>{`${label} `}</>
        {optionalLabel && (
          <span className="text-xs text-gray-400">{optionalLabel}</span>
        )}
      </label>
      <div className="mt-1">{children}</div>
    </div>
  );
};

export { FormItem };
